import InvoicePdfRegenerationWarning from './component';

export default InvoicePdfRegenerationWarning;